import { render, staticRenderFns } from "./CategoriaProductCard.vue?vue&type=template&id=3678255f&scoped=true&"
import script from "./CategoriaProductCard.vue?vue&type=script&lang=js&"
export * from "./CategoriaProductCard.vue?vue&type=script&lang=js&"
import style0 from "./CategoriaProductCard.vue?vue&type=style&index=0&id=3678255f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3678255f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VCardTitle,VChip,VHover,VIcon,VImg})
